/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import './servicios-incluidos.css';

class ServiciosIncluidos extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { iconos } = this.props;

    const servicios = iconos.map((item, index) => (
      <div key={index} className='item-container'>
        <span className={`color-dinamico icono fa ${iconos[index]}`} />
        <span className='descripcion'>{item.charAt(0).toUpperCase() + item.slice(1)}</span>
      </div>
    ));

    return this.props.iconos.length > 0
      ? (
        <div className='services-container'>
          {servicios}
        </div>
      )
      : (<div />);
  }
}

export default ServiciosIncluidos;
